<template>
  <div class="page-tickets" v-scroll-spy="scrollPos">

    <top-subpage-section>
      <page-header title="Tickets">
        <div class="columns is-gapless is-vcentered is-flex-mobile has-text-centered" :class="[{ 'is-centered': !isDesktop }]">
          <div class="column" v-if="isDesktop">&nbsp;<!-- stub --></div>
          <div v-for="subnav in subnavs" key="subnav.title" class="column is-narrow subnav-item">
            <!-- <a :href="subnav.section ? ($route.name + '?anchor=' + subnav.section) : subnav.route" @click="$event.preventDefault();onScrollTo(subnav.route, subnav.section)"> -->
            <!-- <a :href="subnav.section ? ($route.name + '?anchor=' + subnav.section) : subnav.route" target="_blank">
              <img src="../assets/ic_tickets.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                {{ subnav.title }}
              </h4>
            </a> -->
            <a title="Coming Soon" style="cursor:not-allowed;">
              <img src="../assets/ic_tickets.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                {{ subnav.title }}
              </h4>
            </a>
          </div>
        </div>
      </page-header>
    </top-subpage-section>

    <div class="page-tickets-sub-section" id="tickets-sub-section">
      <page-subheader title="Purchase Tickets"></page-subheader>
      <div-container>
        <div-columns paddingTop="0">
          <div v-html="content1"></div>
          <!-- <ul>
            <li>
              Friday Night Entrance Ticket: $15 per person presale | $20 per person at the gate
            </li>
            <li>
              Saturday Entrance Ticket: $5 per person in advance &amp; at the gate
            </li>
            <li>
              Saturday's People's Choice Competition Tasting Ticket: $10 per person (* Saturday Entrance Ticket Required)
            </li>
            <li>
              Kids 6 &amp; Under get in FREE!
            </li>
          </ul> -->
          <div style="position:relative;">
            <h4 v-if="(subnavs[0].route && subnavs[0].route.length > 0) && !disabled" class="button is-primary button-ticket" style="margin-top:30px;position:relative;">
              <a :href="subnavs[0].route" target="_blank">Purchase Here</a>
            </h4>
            <h4 v-else class="button is-primary button-ticket disabled" disabled="true"
              style="margin-top:30px;position:relative;">
              <a :href="'#'" @click="$event.preventDefault();">Coming Soon</a>
            </h4>
            <!-- <div style="font-size:0.8em;font-weight:bold;color:white;text-transform:uppercase;letter-spacing:0.08em;font-family:Oswald,sans-serif;position:absolute;top:0;left:0;transform:translate(0,0px);transform:rotate(-4deg) translate(-10%,160%);background-color:rgba(0,0,0,0.5);">
              Online ticket sales coming soon!
            </div> -->
          </div>
          <div v-html="content2"></div>
          <!-- <p style="padding-top:30px;padding-bottom:15px;">
            or available at:
          </p>
          <p>
            <span class="main">First National Bank</span><br />
            Main Office<br />
            626 N Liberty St<br />
            Waynesboro, GA 30830<br />
          </p>
          <p style="padding-top:15px;">
            <span class="main">First National Bank</span><br />
            6th Street Branch<br />
            528 West 6th Street<br />
            Waynesboro, GA 30830<br />
          </p>
          <p>
            <a href="http://www.fnbwaynesboro.com/" target="_blank">www.fnbwaynesboro.com</a><br />
          </p>
          <p>
            <a href="https://www.google.com/maps/preview/place/First+National+Bank+626+N+Liberty+St+Waynesboro%2C+GA+30830" target="_blank"><i class="fa fa-map-marker fa-links" style="vertical-align:middle;font-size:1.4em;"></i>&nbsp;&nbsp; Get Directions</a>
          </p> -->
        </div-columns>
      </div-container>
    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageHeader from '@/components/PageHeader'
import PageSubheader from '@/components/PageSubheader'
import TopSubpageSection from '@/components/TopSubpageSection'

export default {
  name: 'tickets',
  components: {
    DivContainer,
    DivColumns,
    PageHeader,
    PageSubheader,
    TopSubpageSection
  },
  data () {
    return {
      subnavs: [{
        // route: 'https://wwwbosshogcookoffcom.ticketleap.com/theboss2021/',
        // route: 'https://wwwbosshogcookoffcom.ticketleap.com/16th-annual-boss-hog-state-championship-cook-off/',
        route: undefined,
        title: 'Tickets'
        // section: 'tickets-sub-section'
      }],
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      content1: undefined,
      content2: undefined,
      disabled: true
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 1000)
    }

    this.$set(this, 'disabled', true)
    this.$set(this, 'content1', undefined)
    this.$set(this, 'content2', undefined)
    this.$set(this.subnavs[0], 'route', undefined)

    try {
      let data = await Site.aboutWithName('bosshog::ticket-content')
      if (data && data.hasOwnProperty('disabled')) {
        this.$set(this, 'disabled', data.disabled)
      }
      if (data && data.content) {
        this.$set(this, 'content1', data.content)
      }
      if (data && data.link) {
        this.$set(this.subnavs[0], 'route', data.link)
      }
    } catch (error) {
      console.error('load error', error)
    }

    try {
      let data = await Site.aboutWithName('bosshog::ticket-addresses')
      if (data && data.content) {
        this.$set(this, 'content2', data.content)
      }
    } catch (error) {
      console.error('load error', error)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-tickets {
  position: relative;

  .page-tickets-sub-section {
    padding-top: 3em;
    padding-bottom: 3em;
  }

  .button-ticket {
    font-family: $font-family-title;
    font-weight: bold;
    margin:10px 10px 10px 0;
    vertical-align:middle;
  }

  .button.button-ticket.is-primary[disabled] {
    color: gray;
    background-color: lightgray;
    cursor: not-allowed;
    a {
      cursor: not-allowed;
    }
  }

  span.main {
    font-family: $font-family-title;
    font-size: 1.4em;
  }
}

</style>



// WEBPACK FOOTER //
// Tickets.vue?6d52056f